import { BehaviorParameters } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';
import { PlacementResult } from '@inter-ikea-core/core';
import { isProduction } from 'utils/platform';
import {
  addSkubbOrganizerOnShelf,
  replaceExistingSkubbOrganizerOnShelf
} from './replaceOrganizerSkubbOnShelf';

const replaceOrganizerOnShelf = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  },
  props
}: BehaviorParameters) => {
  const target = coreApi.entities.findSelectedEntity();
  const devMode = !isProduction();

  const product = products.find(product => product.coreProductId === props.coreProductId);

  if (!target || !product) return;

  const currentAccessories = coreApi.entities.getDescendantsWithOneOfProductTypes(target, [
    ProductType.PAX_SKUBB_STORAGE_CASES,
    ProductType.PAX_SKUBB_SHOE_BOXES,
    ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
    ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH,
    ProductType.PAX_SKUBB_STORAGE_BOXES,
    ProductType.PAX_HEMMAFIXARE_SHOE_BOX,
    ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
    ProductType.PAX_SKUBB_STORAGE_CASE_WRAP
  ]);

  const currentProductIsOfOrganiserType =
    product?.type === ProductType.PAX_SKUBB_STORAGE_CASES ||
    product?.type === ProductType.PAX_SKUBB_SHOE_BOXES ||
    product?.type === ProductType.PAX_SKUBB_STORAGE_BOXES ||
    product?.type === ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP ||
    product?.type === ProductType.PAX_HEMMAFIXARE_SHOE_BOX;

  const selectedEntityWidth = coreApi.entities.getEntityComSize(target)?.width;

  let placementResults: PlacementResult[] = [];

  currentAccessories.forEach(accessory => coreApi.entities.delete(accessory));

  if (currentProductIsOfOrganiserType) {
    const targetBehavior = currentAccessories.length
      ? replaceExistingSkubbOrganizerOnShelf
      : addSkubbOrganizerOnShelf;

    placementResults = targetBehavior(
      coreApi,
      product,
      target,
      selectedEntityWidth,
      props.coreProductId
    );
  } else if (selectedEntityWidth === 500) {
    placementResults.push(coreApi.products.addToTarget(props.coreProductId, target));
  } else {
    placementResults.push(
      coreApi.products.addToTarget(props.coreProductId, target),
      coreApi.products.addToTarget(props.coreProductId, target)
    );
  }

  const validPlacements = placementResults.filter(({ valid }) => valid);

  if (devMode && validPlacements.length !== placementResults.length)
    // eslint-disable-next-line no-console
    console.warn('invalid placement when trying to place a storage case');
};

export default replaceOrganizerOnShelf;
